<script setup>
import CloudCard from '@/components/ui/CloudCard.vue'
import ImageCarousel from '@/components/ui/ImageCarousel.vue'

const images = [
  { src: '/images/spiritual-1.jpg', alt: 'Zachte begeleiding' },
  { src: '/images/spiritual-2.jpg', alt: 'Verbinding en ruimte' },
  { src: '/images/spiritual-3.jpg', alt: 'Helder leven' },
]
</script>

<template>
  <!-- Hero -->
  <section class="section">
    <div class="wrap hero-grid">
      <div class="hero-copy">
        <h1>Welkom thuis</h1>
        <p class="lead">
          Dat is wat ik je toewens.<br>
          Thuis komen bij jezelf.<br>
          In je hoofd, in je lijf, in je gevoel.
        </p>
        <p>
          Misschien ben je op zoek naar meer rust.<br>
          Misschien loop je ergens in vast.<br>
          Of voel je gewoon dat er iets mag veranderen.<br>
          Je hoeft niet precies te weten wat.<br>
          Nieuwsgierigheid is genoeg.
        </p>
        <div class="actions">
          <router-link class="btn btn-primary" to="/spirituele-coaching">Ontdek de begeleiding</router-link>
          <router-link class="btn btn-ghost" to="/contact-2">Contact</router-link>
        </div>
      </div>
      <ImageCarousel :images="images" aspect="21/9" />
    </div>
  </section>

  <!-- Samen op weg -->
  <section class="section">
    <div class="wrap" style="display:grid; gap: var(--sp-4);">
      <h2>Samen op weg</h2>
      <p>
        Ik bied ruimte om stil te staan bij wat er werkelijk bij jou speelt.
        Met spirituele coaching door middel van
        <router-link to="/wat-is-reiki" class="jargon-link">Reiki</router-link> en
        <router-link to="/elementen-healing" class="jargon-link">Elementen</router-link> behandelingen en
        <router-link to="/wat-is-leela" class="jargon-link">Leela</router-link> sessies.
      </p>
      <p>
        Niet om je te vertellen hoe het moet.<br>
        Jij bent de motor.<br>
        Ik loop een stukje met je mee.<br>
        Op jouw manier.<br>
        In jouw tempo.
      </p>
    </div>
  </section>

  <!-- Cloud blocks -->
  <section
    class="section cloud-section"
    style="background: var(--bg-soft); border-block: 1px solid var(--divider);"
  >
    <div class="wrap cloud-section__inner" style="display:grid; gap: 28px;">
      <h2>Sfeerbeelden</h2>

      <div class="grid-2">
        <CloudCard tone="primary">
          <h3></h3>
          <p></p>
        </CloudCard>

        <CloudCard tone="accent">
          <h3></h3>
          <p></p>
        </CloudCard>
      </div>
    </div>
  </section>

  <!-- Ontdek wat bij jou past -->
  <section class="section">
    <div class="wrap" style="display:grid; gap: var(--sp-4);">
      <h2>Ontdek wat bij jou past</h2>
      <p>Lees verder over mijn manier van begeleiden, over Reiki en Elementen of over wie ik ben.</p>
      <p>
        Misschien herken je iets.<br>
        En misschien voel je dan:<br>
        hier wil ik wel eens over praten.
      </p>
      <div class="actions">
        <router-link class="btn btn-primary" to="/spirituele-coaching">Ontdek de begeleiding</router-link>
        <router-link class="btn btn-ghost" to="/wie-ben-ik-2">Wie ben ik</router-link>
      </div>
    </div>
  </section>

  <!-- CTA -->
  <section class="section">
    <div class="wrap" style="display:grid; gap: 12px;">
      <h2>Klaar voor een eerste stap?</h2>
      <p>
        Neem gerust contact op voor een vrijblijvende kennismaking.<br>
        Geen ingewikkeld verhaal.<br>
        Gewoon even praten.
      </p>
      <div class="actions">
        <router-link class="btn btn-primary" to="/contact-2">Neem contact op</router-link>
      </div>
      <p class="page-aum">
        <span class="page-aum-rule" aria-hidden="true"></span>
        <span class="page-aum-dot" aria-hidden="true">◦</span>
        <span class="page-aum-mark">AUM</span>
        <span class="page-aum-dot" aria-hidden="true">◦</span>
        <span class="page-aum-rule page-aum-rule--right" aria-hidden="true"></span>
      </p>
    </div>
  </section>
</template>

<style scoped>
/* Soft clouds drifting slowly behind the "Sfeerbeelden" band.
   Purely decorative: clipped to the section, ignores pointer events,
   and holds still for anyone who prefers reduced motion. */
.cloud-section {
  position: relative;
}
/* A background image never overflows its own box, so no clipping (and no
   risk to the cards' puffs) is needed here. */
.cloud-section::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    url("data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='520'%20height='160'%3E%3Cg%20fill='%23ffffff'%3E%3Cellipse%20cx='120'%20cy='112'%20rx='84'%20ry='34'/%3E%3Ccircle%20cx='104'%20cy='74'%20r='38'/%3E%3Ccircle%20cx='150'%20cy='84'%20r='32'/%3E%3Ccircle%20cx='70'%20cy='86'%20r='26'/%3E%3Cellipse%20cx='372'%20cy='70'%20rx='58'%20ry='22'/%3E%3Ccircle%20cx='356'%20cy='46'%20r='24'/%3E%3Ccircle%20cx='392'%20cy='52'%20r='20'/%3E%3Ccircle%20cx='332'%20cy='54'%20r='16'/%3E%3C/g%3E%3C/svg%3E")
    repeat-x 0 12% / 520px 160px;
  opacity: 0.4;
  animation: cloud-drift 120s linear infinite;
}
.cloud-section__inner {
  position: relative; /* sit above the drifting layer */
}

@keyframes cloud-drift {
  from { background-position-x: 0; }
  to   { background-position-x: 520px; }
}

@media (prefers-reduced-motion: reduce) {
  .cloud-section::before { animation: none; }
}
</style>
